import React from "react";
import PropTypes from "prop-types";

function Sorter({ sortBy, activeSorter, field }) {
	function isActiveSort(order) {
		return activeSorter.field === field && activeSorter.order === order;
	}

	return (
		<>
			<div className="pull-right">
				<button
					className={`sorter-button ${isActiveSort(`desc`) ? `active` : ``}`}
					onClick={() => sortBy(field, `desc`)}
				>
					<span className="fa fa-sort-alpha-desc" aria-hidden="true" />
				</button>
				<button
					className={`sorter-button ${isActiveSort(`asc`) ? `active` : ``}`}
					onClick={() => sortBy(field, `asc`)}
				>
					<span className="fa fa-sort-alpha-asc" aria-hidden="true" />
				</button>
			</div>
		</>
	);
}

Sorter.propTypes = {
	activeSorter: PropTypes.shape({
		field: PropTypes.string,
		order: PropTypes.oneOf([`asc`, `desc`])
	}).isRequired,
	field: PropTypes.string.isRequired,
	sortBy: PropTypes.func.isRequired
};

export default Sorter;
